











import Vue from 'vue'
import { store } from 'base/store'
import { EventService } from '../../base/services/EventService'

export default Vue.extend({
  computed: {
    eventService() {
      return EventService
    },
    accessAllowedDashboard() {
      return this.$store.state.user.access.dashboard
    }
  }
})
